import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import OrderCard from "./OrderCard";
import cookie from "react-cookies";
import Loading from "../../Others/Loading";
import {
  getOrderDetailsRashan,
  getPastOrderStatusRashan,
} from "../../Request/OrderRequests";
import MenuBar from "../MenuBar";
import Signin from "../SignIn";
import Main from "../../Store/Cart/Components/Login/Main";

function OrderTab() {
    const navigate = useNavigate();
    const [currentState, setState] = useState("cartLoginSpan");
    const user = useSelector((s) => s.user.info);
    const [menu, setMenu] = useState("Active");
    const [orders, setOrders] = useState(null);
    const [pastOrders, SetpastOrders] = useState(0);
    useEffect(() => {
      if (user?.userHash) {
        getOrderDetailsRashan(cookie.load("uid"))
          .then((res) => setOrders(res.reverse()))
          .catch((err) => console.log(err));
      }
    }, [user]);
    useEffect(() => {
      if (user?.userHash) {
        getPastOrderStatusRashan(cookie.load("uid"))
          .then((res) => SetpastOrders(res?.[0]?.pastOrder || 0))
          .catch((err) => console.log(err));
      }
    }, [user]);

    // console.log(orders);

  return !user?.userHash ? (
    <>
      <Signin current={currentState} />
      <Main setState={setState} />
      {/* <SignUp setState={user?.phn}/> */}
      <MenuBar active="Orders" />
    </>
  ) : orders !== null ? (
    <>
      <div
        className="sticky-top border-bottom"
        style={{ backgroundColor: "white" }}
      >
        <div className="py-2 d-flex align-items-center bg-orange text-light">
          <div className="w-75 mt-auto ps-2 text-uppercase">
            <span className="bi bi-chevron-left d-flex align-items-center" onClick={() => navigate(-1)}>
              Back
            </span>
          </div>
          <div className="w-100 fs-5 text-center">My Orders</div>
          <div className="w-75"></div>
        </div>
        <div className="contaniner d-flex">
          <div
            className="d-flex mx-auto w-100"
            style={{
            }}
          >
            <div
              className={
                "fs-6 w-100 mx-2 text-center p-2 py-1 mt-1" +
                (menu === "Active" ? " border-bottom border-4 border-orange" : " mb-1")
              }
              // style={{ paddingTop: "8px", paddingBottom: "10px" }}
              onClick={() => setMenu("Active")}
            >
              <div className="m-auto">Active</div>
            </div>
            <div
              className={
                "fs-6 w-100 mx-2 text-center p-2 py-1 mt-1" +
                (menu === "Past" ? " border-bottom border-4 border-orange" : " mb-1")
              }
              // style={{ paddingTop: "8px", paddingBottom: "10px" }}
              onClick={() => setMenu("Past")}
            >
              <div className="my-auto">
                Past {Boolean(pastOrders) && `(${pastOrders})`}
              </div>
            </div>
          </div>
        </div>
      </div>
      {menu === "Active"
        ? orders
            ?.filter((o) => o?.status === "Pending" || o?.status === "Accepted")
            .map((key, i) => {
              return <OrderCard key={i} order={key} reload={setOrders} />;
            })
        : orders
            ?.filter(
              (o) => o?.status === "Cancelled" || o?.status === "Delivered"
            )
            .map((key, i) => {
              return <OrderCard key={i} order={key} reload={setOrders} />;
            })}
      <div className="d-flex " style={{ height: "calc(100vh - 144px)" }}>
        <div
          className="d-flex flex-column m-auto w-50"
          onClick={() => {
            navigate("/home");
          }}
        >
          <div className="mt-1"></div>
          <div className="my-auto mx-auto">
            <i
              className="bi bi-plus-circle mx-auto text-orange lh-1"
              style={{ fontSize: "65px" }}
            ></i>
          </div>
          <span
            className="text-muted mx-auto fw-bolder pt-1 pb-2"
            style={{ fontSize: "18px" }}
          >
            Buy Something
          </span>
        </div>
      </div>
      <MenuBar active="Orders" />
    </>
  ) : (
    <Loading text="Getting your orders" />
  );
}

export default OrderTab;
